import { FormAutocompleteField, FormAutocompleteFieldProps } from '@razz-team/ui-web';
import { useMemo } from 'react';
import { isEmpty } from 'lodash-es';
import { usePopCodesQuery } from '../../api/transfers';

export function PopCodeField<
  Multiple extends boolean = false,
  DisableClearable extends boolean = false,
>({
  country,
  currency,
  provider,
  ...props
}: Omit<
  FormAutocompleteFieldProps<string, Multiple, DisableClearable>,
  'options' | 'getOptionLabel'
> & {
  country: string | null | undefined;
  currency: string | null | undefined;
  provider: string | null | undefined;
}) {
  const { data: codes, isPending } = usePopCodesQuery({ country, currency, provider });

  const found = useMemo(() => {
    if (isEmpty(codes)) return undefined;
    const options = Object.keys(codes);
    const getOptionLabel = (key: string) => codes[key] ?? key;

    return { options, getOptionLabel };
  }, [codes]);

  return found ? (
    <FormAutocompleteField
      {...props}
      options={found.options}
      getOptionLabel={found.getOptionLabel}
      loading={isPending}
    />
  ) : null;
}
